import React, { useState } from "react";

import { Box, Typography, Checkbox, styled, Button } from "@mui/material";
import Navbar from "../navbar/Navbar";
import { Services } from "../forms";
import HeroText from "../heroText/HeroText";
import { colors } from "../../configs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const OptionsButton = styled(Button)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#FFFFFF",
  padding: "15px 15px",
  borderRadius: "15px",
  marginRight: "5px",
  textTransform: "capitalize",
  "&: hover": {
    backgroundColor: "#eeeeee",
    color: "black",
  },
});
const Hero = () => {
  const [checkLugage, setCheckedLugage] = useState<boolean>(false);
  const [isDirect, setIsDirect] = useState<boolean>(false);
  const [moreLessDays, setMorelessDays] = useState<boolean>(false);
  const [layovers, setLayovers] = useState<boolean>(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        backgroundImage: "url(../../assets/home_background.png)",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        width: "100%",
        height: "100vh",
      }}>
      <Navbar />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}>
        <Box>
          <HeroText />

          <Services
            noStop={isDirect}
            checkedLugageIn={checkLugage}
            moreLessDay={moreLessDays}
            stopLessThree={layovers}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              margin: "15px 0 0 0",
            }}>
            <OptionsButton onClick={() => setCheckedLugage(!checkLugage)}>
              {checkLugage && (
                <CheckCircleIcon
                  sx={{
                    color: colors.main,
                    marginRight: "2px",
                  }}
                />
              )}
              <Typography
                variant="body2"
                component="b"
                sx={{
                  color: "gray",
                  fontSize: "12px",
                }}>
                {"Checked Luggage included"}
              </Typography>
            </OptionsButton>
            <OptionsButton onClick={() => setIsDirect(!isDirect)}>
              {isDirect && (
                <CheckCircleIcon
                  sx={{
                    color: colors.main,
                    marginRight: "2px",
                  }}
                />
              )}
              <Typography
                variant="body2"
                component="b"
                sx={{
                  color: "gray",
                  fontSize: "12px",
                }}>
                {"Direct"}
              </Typography>
            </OptionsButton>
            <OptionsButton onClick={() => setMorelessDays(!moreLessDays)}>
              {moreLessDays && (
                <CheckCircleIcon
                  sx={{
                    color: colors.main,
                    marginRight: "2px",
                  }}
                />
              )}
              <Typography
                variant="body2"
                component="b"
                sx={{
                  color: "gray",
                  fontSize: "12px",
                }}>
                {"+/- 3jours"}
              </Typography>
            </OptionsButton>
            <OptionsButton onClick={() => setLayovers(!layovers)}>
              {layovers && (
                <CheckCircleIcon
                  sx={{
                    color: colors.main,
                    marginRight: "2px",
                  }}
                />
              )}
              <Typography
                variant="body2"
                component="b"
                sx={{
                  color: "gray",
                  fontSize: "12px",
                }}>
                {"Layovers < 3h"}
              </Typography>
            </OptionsButton>
          </Box>
        </Box>
        <Box>
          <img
            src="/assets/steward.png"
            alt=""
            className=""
            style={{ width: "200px" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
